<header class="container-fluid container-fluid-xs bg-{{ color }}">
  <ng-content></ng-content>
</header>
